import { observer } from 'mobx-react-lite';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { isFeatureEnabled } from 'owa-feature-flags';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import SingleRecipientType from 'owa-service/lib/contract/SingleRecipientType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getPresenceFromStore, lazyTryRegisterForPresenceUpdates } from 'owa-skype-for-business';
import * as React from 'react';
import {
    useLivePersonaCard,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';
import { usePersonaRingBehavior } from 'owa-persona/lib/components/PersonaRingBehavior';

export interface SenderImageProps {
    sender: SingleRecipientType;
    displaySelf: boolean;
    style?: string;
    isUnauthenticatedSender?: boolean;
    size?: PersonaSize;
    showPresence?: boolean;
    displayPersonaHighlightRing?: boolean;
}

const SenderImage = (props: SenderImageProps) => {
    let name = props.sender && props.sender.Mailbox ? props.sender.Mailbox.Name : null;
    const mailBoxType =
        props.sender && props.sender.Mailbox ? props.sender.Mailbox.MailboxType : null;
    let emailAddress =
        props.sender && props.sender.Mailbox ? props.sender.Mailbox.EmailAddress : null;
    let personaType = undefined;
    if (props.displaySelf) {
        const userConfiguration = getUserConfiguration();
        name = userConfiguration.SessionSettings.UserDisplayName;
        emailAddress = userConfiguration.SessionSettings.UserEmailAddress;
        personaType = 'User';
    }

    return (
        <SenderImageDiv
            name={name}
            emailAddress={emailAddress}
            style={props.style}
            personaType={personaType}
            mailBoxType={mailBoxType}
            isUnauthenticatedSender={props.isUnauthenticatedSender}
            clientScenario="SenderImageDiv"
            size={props.size}
            showPresence={props.showPresence}
            displayPersonaHighlightRing={props.displayPersonaHighlightRing}
        />
    );
};
export default SenderImage;

export interface SenderImageDivProps extends PersonaCardBehaviorProps {
    style?: string;
    size?: PersonaSize;
    showPresence?: boolean;
    displayPersonaHighlightRing?: boolean;
}

const SenderImageDiv = observer(function SenderImageDiv(props: SenderImageDivProps) {
    const PersonaCardBehavior = useLivePersonaCard(props);
    const PersonaRingBehavior = usePersonaRingBehavior({
        displayPersonaHighlightRing: props.displayPersonaHighlightRing,
        personaSize: props.size || PersonaSize.size40,
        identifiers: {
            OlsPersonaId: props.olsPersonaId,
            Smtp: props.emailAddress,
            PersonaType: props.personaType,
        },
        isUnauthenticatedSender: props.isUnauthenticatedSender,
        mailBoxType: props.mailBoxType,
        composeEmailOverride: props.composeEmailOverride,
    });

    React.useEffect(() => {
        if (isFeatureEnabled('fwk-skypeBusinessV2') && props.showPresence) {
            lazyTryRegisterForPresenceUpdates.import().then(tryRegisterForPresenceUpdates => {
                tryRegisterForPresenceUpdates(props.emailAddress);
            });
        }
    }, []);

    const presence = props.showPresence ? getPresenceFromStore(props.emailAddress) : undefined;

    return (
        <PersonaCardBehavior>
            <div className={props.style}>
                <PersonaRingBehavior>
                    <PersonaControl
                        name={props.name}
                        emailAddress={props.emailAddress}
                        size={props.size || PersonaSize.size40}
                        showUnknownPersonaCoin={props.isUnauthenticatedSender}
                        presence={presence}
                        mailboxType={props.mailBoxType}
                    />
                </PersonaRingBehavior>
            </div>
        </PersonaCardBehavior>
    );
});
